import { Box, Button } from '@mui/material'
import cx from 'classnames'

import { useRankData } from './hooks/useRankData'
import PlusIcon from '../../Icons/PlusIcon'
import List from './components/List'
import Chart from './components/Chart'

import useStyles from './style'
import useGlobalStyles from '../style'

const Rank = ({ productData, setFooterHeight }) => {
  const { isChangesExist, saveChanges, addNewKeywordTemplate, isPossibleToAddNewKeyword, isItemsUpdating, footerRef } =
    useRankData({
      productData,
      setFooterHeight,
    })
  const globalClasses = useGlobalStyles()
  const classes = useStyles()

  return (
    <>
      <Box className={cx(globalClasses.wrapper_body, classes.body)}>
        <Box className={classes.chart}>
          <Chart />
        </Box>
        <Box className={classes.list}>
          <List />
        </Box>
      </Box>
      <Box className={cx(globalClasses.wrapper_footer, classes.footer)} ref={footerRef}>
        {/* <Box className={classes.footer__text}> */}
        {/* See Organic Rank Management-module for even more detailed insights <br /> and management options in bulk. */}
        {/* </Box> */}
        <Box className={classes.footer__controls}>
          <Button
            variant="outlined"
            color="secondary"
            className={globalClasses.create}
            onClick={addNewKeywordTemplate}
            disabled={!isPossibleToAddNewKeyword || isItemsUpdating}
          >
            <PlusIcon />
            Keyword
          </Button>
          <Button
            variant="contained"
            color="secondary"
            disabled={!isChangesExist || isItemsUpdating}
            className={globalClasses.save_btn}
            onClick={saveChanges}
          >
            Save changes
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default Rank
